import { memo } from 'react';
import { API_PATH } from '@zmedia/bm-soccer-ui/service/ContentService';
import { ContentSection } from '@zmedia/bm-soccer-ui/modules/content';

export function PlayerNews(props: any) {
    const { items = [], name } = props;
    const options = {
        url: API_PATH.GET_LIST,
        params: {
            query: name,
            listType: 'byQuery',
            page: items.length > 0 ? 2 : 1,
        },
    };

    return <ContentSection {...props} options={options} alignItem="vertical" />;
}

export default memo(PlayerNews);
